import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'post'

export default class OspreyTemplateMessagePreview extends BaseAction {
    constructor(dataKey, onError) {
        const id = 'c0a357e1-0adb-4b33-a9a8-be9bbbc51cc8'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    messagePreview(data, id) {
        this.path = `/${resource}/${id}/preview`
        this.params = {
            ownerOrn: data.ownerOrn.value,
            ...data
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/templates/template-message-preview.js